'use client';


import { Button } from 'src/general/components/Button/Button';
import { Divider } from 'src/general/components/Divider/Divider';
import { pushToDataLayer } from 'src/utils/pushToDataLayer';

export const HeroCTAButtons = () => {

  return (
    <div className="flex gap-2 sm:flex-col sm:gap-1">
      <Button
        data-testid="hero-cta-find-car"
        href="/used-cars"
        fullWidth
        variant="accent"
        onClick={() => {
          pushToDataLayer({
            event: 'search_click_browse_all_cars',
          });
        }}
      >
        Find my next car
      </Button>
      <div className="hidden sm:block">
        <Divider>or</Divider>
      </div>
      <Button
        data-testid="hero-cta-sell-car"
        href="/sell-or-trade-in-my-car"
        fullWidth
        variant="secondary"
        onClick={() => {
          pushToDataLayer({
            event: 'homepage_click_sell_my_car',
          });
        }}
      >
        Sell my car
      </Button>
    </div>
  );
};
